module.exports = `const EightyApp = require('eighty-app');
const app = new EightyApp();

app.processDocument = function(html, url, headers, status, cheerio, extras) {
    const data = {};
    return JSON.stringify(data);
};
app.parseLinks = function(html, url, headers, status, cheerio, extras) {
    return [];
}

module.exports = function() { 
    return app;
};`;



// WEBPACK FOOTER //
// ./src/app_template.js